import brands from '../../api/brands'

export default {
    namespaced: true,
    state: () => ({
        loading: false,
        items: []
    }),
    getters: {},
    actions: {
        getBrands ({ commit }) {
            commit('setLoading', true)
            return brands.getBrands().then((response) => {
                commit('setItems', response.data.brands)
                commit('setLoading', false)
            })
        }
    },
    mutations: {
        setLoading (state, bool) {
            state.loading = bool
        },
        setItems (state, brands) {
            state.items = brands
        }
    }
}
